import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from '../../customer.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-customer-feedback',
  templateUrl: './customer-feedback.component.html',
  styleUrls: ['./customer-feedback.component.scss']
})
export class CustomerFeedbackComponent implements OnInit {
  model: any = {};
  alert = false;
  id: number;
  public href = '';
  url = 'asdf';
  spin: boolean;
  ids: string;
  modalRef: BsModalRef;
  feedbacks: any = [];
  customerId: number;
  constructor(
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.href = this.router.url;
    this.ids = this.href.split('/')[3];
    // tslint:disable-next-line: radix
    this.id = parseInt(this.ids);
    this.getAddressCustomer();
  }
  getAddressCustomer() {
    this.customerService.getCustomerFeedback(this.id).subscribe(Response => {
      this.feedbacks = Response;
      if (!this.feedbacks[0].Rates) {
        this.spin = false;
      } else {
        this.spin = true;
      }      // console.log('adressssssssssssses', this.addresses);

    });
  }

}
